// Addresses used one-letter prefixes (/f/…, /r/…) until October 2026. Links people saved or shared from then still
// work: each old address maps onto its word-named one, keeping the id and everything after it.
const MOVED: Record<string, string> = {
  f: 'circle',
  b: 'book',
  r: 'recipe',
  c: 'cookbook',
  a: 'album',
  ph: 'photo',
  m: 'moment',
  p: 'person',
}

export const OLD_PREFIXES = Object.keys(MOVED)

export function newPath(path: string): string | null {
  if (path === '/families/new') return '/circle/new'
  const [, prefix = '', rest = ''] = /^\/([a-z]+)(\/.*)$/.exec(path) ?? []
  return Object.hasOwn(MOVED, prefix) ? `/${MOVED[prefix]}${rest}` : null
}
